import { currencyFormatter } from "../util/formatCurrency";

export const importFeeNotice = ({ perShipment, destination, reason }) =>
  `Shipping to ${destination} includes ${currencyFormatter.format(
    perShipment / 100,
  )} per package for ${reason}.`;
